import { crudActions } from '../factories'

export const { find, setList, clearList, get, save, remove } = crudActions({ name: 'reservations' })

export const cancel = async ({ props: { _id, scope }, reservationsService, store }) => {
  const reservation = await reservationsService.patch(_id, { cancelledAt: new Date(), scope })
  store.set(`reservations.entities.${_id}.cancelledAt`, reservation.cancelledAt)
}
